/* [ELICO 2026-10-07] Tabs for sections/elico-pdp-routine.liquid (data-epr-*): one tab per product
   routine; arrow keys move between tabs (WAI-ARIA tabs pattern, automatic activation). The CTA
   without a link scrolls to the bundle buy box. */
(function () {
  'use strict';
  function init(sec) {
    if (sec.getAttribute('data-epr-ready')) return;
    sec.setAttribute('data-epr-ready', '1');
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-epr-tab]'));
    var panels = sec.querySelectorAll('[data-epr-panel]');
    function select(i, focus) {
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p, k) {
        p.hidden = k !== i;
        if (k === i) {
          var row = p.querySelector('[data-epc-track]'); if (row) row.scrollLeft = 0;
          // the carousel measured itself while hidden: let it re-measure (counter, progress, buttons)
          window.dispatchEvent(new Event('resize'));
        }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, j = -1;
        if (e.key === 'ArrowRight') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        if (j >= 0) { select(j, true); e.preventDefault(); }
      });
    });
    // "Velg din pakke": bring the bundle's add-to-cart into view and focus it. scrollIntoView
    // works whatever element scrolls the page (window or a theme wrapper).
    sec.querySelectorAll('[data-epr-to-buybox]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector('[data-bbv4-atc-wrap]') || document.querySelector('[data-bbv4-root]');
        if (!target) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        var btn = target.querySelector('[data-bbv4-atc]');
        if (btn) { try { btn.focus({ preventScroll: true }); } catch (err) { btn.focus(); } }
      });
    });
  }
  function boot() { document.querySelectorAll('[data-epr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
